import React, { useEffect, useState } from 'react'
import { ArrowFatDown, ArrowFatUp, Play, Trash } from '@phosphor-icons/react'
import ModalDeleteContent from './ModalDeleteContent'
import { formatDateTime } from '../utils'
import ContentSourceBadge from './ContentSourceBadge'
const ProjectContents = ({
  contents,
  contentPath,
  project_path,
  onSearchResults,
  onContentDelete,
}) => {
  const [open, setOpen] = useState(false)
  const [content, setContent] = useState(null)
  const [sort, setSort] = useState('created_at')
  const [direction, setDirection] = useState('asc')

  const handleContentSearch = async () => {
    try {
      const response = await fetch(
        `${project_path}?sort=${sort}&direction=${direction}`, {
          headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').
              getAttribute('content'),
            'Accept': 'application/json',
          },
        })

      if (response.ok) {
        const contents = await response.json()
        onSearchResults(contents)
      }
    } catch (error) {
      console.error('Error fetching contents:', error)
    }
  }

  const handleContentDelete = async () => {
    try {
      const response = await fetch(`/projects/${content?.project_id}/contents/${content?.id}`, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').
            getAttribute('content'),
          'Accept': 'application/json',
        },
      })

      if (response.ok) {
        setOpen(false)
        setContent(null)
        onContentDelete(content)
      }
    } catch (error) {
      console.error('Error deleting content:', error)
      setOpen(false)
      setContent(null)
    }
  }

  const openDeleteModal = (content) => {
    setContent(content)
    setOpen(true)
  }

  useEffect(() => {
    handleContentSearch()
  }, [sort, direction])

  return (
    <div className="overflow-x-auto h-96">
      <ModalDeleteContent open={open} onClose={() => setOpen(false)}
                          onDelete={handleContentDelete} content={content}/>
      <table
        className="table table-pin-rows table-zebra border-b-2 border-gray-200">
        <thead>
        <tr>
          <th onClick={() => {
            setSort('title')
            setDirection(direction === 'asc' ? 'desc' : 'asc')
          }}>
            <div className="flex flex-row items-center gap-2 link link-hover">
              <label>
                Title
              </label>
              <div>
                {direction === 'desc' ? <ArrowFatDown size={16} weight="fill"
                                                      color="teal"/> :
                  <ArrowFatUp size={16} weight="fill" color="teal"/>}
              </div>
            </div>
          </th>
          <th onClick={() => {
            setSort('source')
            setDirection(direction === 'asc' ? 'desc' : 'asc')
          }}>
            <div className="flex flex-row items-center gap-2 link link-hover">
              <label>
                Source
              </label>
              <div>
                {direction === 'desc' ? <ArrowFatDown size={16} weight="fill"
                                                      color="teal"/> :
                  <ArrowFatUp size={16} weight="fill" color="teal"/>}
              </div>
            </div>
          </th>
          <th onClick={() => {
            setSort('created_at')
            setDirection(direction === 'asc' ? 'desc' : 'asc')
          }}>
            <div className="flex flex-row items-center gap-2 link link-hover">
              <label>
                Created At
              </label>
              <div>
                {direction === 'desc' ? <ArrowFatDown size={16} weight="fill"
                                                      color="teal"/> :
                  <ArrowFatUp size={16} weight="fill" color="teal"/>}
              </div>
            </div>
          </th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody>
        {contents.map((content) => (
          <tr key={content?.id} className="hover">
            <td>
              <a
                className="link link-hover"
                href={contentPath.replace(':id', content?.id)}>
                {content?.title}
              </a>
            </td>
            <td><ContentSourceBadge source={content?.source}/></td>
            <td>{formatDateTime(content?.created_at)}</td>
            <td>
              <div className="flex gap-2">
                <button className="btn btn-sm btn-error btn-outline"
                        onClick={() => openDeleteModal(content)}>
                  <Trash size={16}/>
                </button>
              </div>
            </td>
          </tr>
        ))}
        </tbody>
      </table>
    </div>
  )
}

export default ProjectContents